// extracted by mini-css-extract-plugin
export var active = "_2u-7";
export var backButton = "_2u-6";
export var clone = "_2u-c";
export var collapseBar = "_2u-h";
export var collapseMode = "_2u-j";
export var collapsed = "_2u-l";
export var dragHandle = "_2u-a";
export var dropdownIcon = "_2u-e";
export var expanding = "_2u-k";
export var hidden = "_2u-r";
export var iconContainer = "_2u-o";
export var iconSwapper = "_2u-q";
export var navItem = "_2u-4";
export var navItemIcon = "_2u-d";
export var navProfile = "_2u-5";
export var notificationCountBadge = "_2u-g";
export var notificationDot = "_2u-p";
export var optionsContainer = "_2u-f";
export var primaryNav = "_2u-0";
export var primaryTab = "_2u-m";
export var secondaryNav = "_2u-1";
export var selected = "_2u-n";
export var settingsNav = "_2u-2";
export var settingsNavItems = "_2u-3";
export var show = "_2u-b";
export var sideNav = "_2u-i";
export var teamItem = "_2u-8";
export var userProfileItem = "_2u-9";